import { jwtDecode } from "jwt-decode";
import api from "../services/axiosConfig";

const fetchMe = async () => {
  const res = await api.post("/auth/me", {});
  if (res.status === 200) {
    return res.data.data.user;
  }
  return null;
};

const AuthService = {
  login: async (user) => {
    try {
      const loginResponse = await api.post("/auth/login", user, {
        headers: { Accept: "application/json" },
      });

      if (loginResponse.status === 200) {
        localStorage.setItem(
          "SkeyegateAuthToken",
          loginResponse.data.data.user.jwt,
        );

        const userData = await fetchMe();
        return userData
          ? { isAuthenticated: true, user: userData }
          : { isAuthenticated: false, error: "Failed to fetch user data" };
      }

      return {
        isAuthenticated: false,
        error: "Login failed with unexpected status",
      };
    } catch (error) {
      console.error("Login error:", error);
      return {
        isAuthenticated: false,
        user: { username: "", role: "" },
        error:
          error.response?.data?.message ||
          error.response?.data?.exception ||
          "An unexpected error occurred during login",
      };
    }
  },

  isAuthenticated: async () => {
    const token = localStorage.getItem("SkeyegateAuthToken");

    if (!token) {
      return { isAuthenticated: false, user: null };
    }

    try {
      const decodedToken = jwtDecode(token);
      const isExpired = decodedToken.exp < Math.floor(Date.now() / 1000);

      if (isExpired) {
        const res = await api.post("/auth/refresh-token", {});

        if (res.status === 200) {
          const newToken = res.data?.data?.newToken;
          if (newToken) {
            localStorage.setItem("SkeyegateAuthToken", newToken);
          }
          const userData = await fetchMe();
          if (!userData) {
            localStorage.removeItem("SkeyegateAuthToken");
            return { isAuthenticated: false, user: null };
          }
          return { isAuthenticated: true, user: userData };
        } else {
          localStorage.removeItem("SkeyegateAuthToken");
          return { isAuthenticated: false, user: null };
        }
      }

      const userData = await fetchMe();
      return userData
        ? { isAuthenticated: true, user: userData }
        : { isAuthenticated: false, user: null };
    } catch (error) {
      console.error("Auth error:", error);
      //localStorage.removeItem("SkeyegateAuthToken");
      return { isAuthenticated: false, user: null };
    }
  },

  logout: async () => {
    try {
      await api.post("/auth/logout", {});
    } catch (error) {
      console.warn(
        "Logout API call failed (proceeding with local cleanup):",
        error,
      );
    }
    localStorage.removeItem("SkeyegateAuthToken");
    return { isAuthenticated: false, user: null };
  },
};

export default AuthService;
